import PropTypes    from 'prop-types';
import randomInt    from 'random-int';
import randomString from '../utils/randomString';

const serviceCategoryShape = {
  '@id':   PropTypes.string.isRequired,
  '@type': PropTypes.string.isRequired,
  id:      PropTypes.string.isRequired,
  name:    PropTypes.string.isRequired,
  slug:    PropTypes.string.isRequired,
  icon:    PropTypes.string.isRequired,
};

const serviceCategoryPropType = PropTypes.shape(serviceCategoryShape);


const generateMockServiceCategory = () => {

  const id = randomString();

  const icons = [
    'fa:fas:up',
    'fa:fas:down',
    'fa:fas:left',
    'fa:fas:right',
    'fa:fas:house',
    'fa:fas:money',
    'fa:fas:clock',
  ];

  const name = randomString(randomInt(12));
  return {
    '@id':   `/service_categories/${id}`,
    '@type': 'http://schema.org/Thing',
    id,
    name,
    slug:    name.toLowerCase(),
    icon:    icons[randomInt(icons.length - 1)],
  };

};


export {
  serviceCategoryShape,
  serviceCategoryPropType,
  generateMockServiceCategory
};


// WEBPACK FOOTER //
// ./src/domain/serviceCategory.js